import { render, staticRenderFns } from "./EpsCard.vue?vue&type=template&id=80111144&scoped=true&"
import script from "./EpsCard.js?vue&type=script&lang=js&"
export * from "./EpsCard.js?vue&type=script&lang=js&"
import style0 from "./EpsCard.scss?vue&type=style&index=0&id=80111144&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80111144",
  null
  
)

export default component.exports